/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SearchDocumentDto } from '../../models/search-document-dto';

export interface Search$Params {
  queryString: string;
}

export function search(http: HttpClient, rootUrl: string, params: Search$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SearchDocumentDto>>> {
  const rb = new RequestBuilder(rootUrl, search.PATH, 'get');
  if (params) {
    rb.query('queryString', params.queryString, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SearchDocumentDto>>;
    })
  );
}

search.PATH = '/api/documents/search';
